import axios from "axios";
import { toast } from "react-toastify";
import { getErrorMessage } from "./errorMessages";

// Flag to prevent multiple toasts for the same error
let isShowingError = false;

// Setup Axios Interceptor for Global Error Handling
export const setupAxiosInterceptors = () => {
  // Response interceptor
  axios.interceptors.response.use(
    (response) => {
      // If response is successful, just return it
      return response;
    },
    (error) => {
      // Prevent multiple toasts at the same time
      if (isShowingError) {
        return Promise.reject(error);
      }

      isShowingError = true;
      setTimeout(() => {
        isShowingError = false;
      }, 300);

      // Get user-friendly error message
      const errorMessage = getErrorMessage(error);
      const status = error.response?.status;

      // Handle specific status codes with different toast types
      switch (status) {
        case 401:
          // Unauthorized - Clear token and redirect to login
          toast.error(errorMessage);
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          // Redirect to login after a short delay
          setTimeout(() => {
            window.location.href = process.env.REACT_APP_LOGIN_URL || "/login";
          }, 1500);
          break;

        case 403:
          // Forbidden
          toast.warning(errorMessage);
          break;

        case 413:
          // Payload Too Large
          toast.error(errorMessage);
          break;

        case 429:
          // Too Many Requests
          toast.warning(errorMessage);
          break;

        case 500:
        case 502:
        case 503:
        case 504:
          // Server Errors
          toast.error(errorMessage);
          break;

        default:
          // Other errors
          if (status >= 400 && status < 500) {
            // Client errors
            toast.warning(errorMessage);
          } else if (status >= 500) {
            // Server errors
            toast.error(errorMessage);
          } else if (!error.response) {
            // Network errors
            toast.error(errorMessage);
          } else {
            // Unknown errors
            toast.error(errorMessage);
          }
      }

      // Always reject the promise so individual handlers can still catch it if needed
      return Promise.reject(error);
    }
  );

  // Request interceptor (optional - for adding auth tokens, etc.)
  axios.interceptors.request.use(
    (config) => {
      // Add auth token to requests if available
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};
